export default __webpack_public_path__ + "static/media/485.80a9c375.jpg";